import { Box, Typography, Stack, styled as muiStyled } from '@mui/material';
import { abyssColors } from '@/theme/colors';

export const AttachmentContainer = muiStyled(Stack)({
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
  height: '100%',
  position: 'relative',
  padding: '4rem',
});

export const textStyle = {
  color: abyssColors.primary[300],
  fontWeight: 400,
};

export const imageStyle = {
  width: '100%',
  backgroundColor: '#000',
};

export const ImageCaption = muiStyled(Typography)({
  marginTop: '16px',
  marginBottom: '32px',
  textAlign: 'center',
  fontWeight: 500,
  fontSize: '1.4rem',
  color: abyssColors.primary[500],
});

export const AttachmentActionContainer = muiStyled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
  background: abyssColors.primary[50],
  border: `1px dashed ${abyssColors.primary[200]}`,
  borderRadius: '5px',
  padding: '24px',
  minHeight: '56px',
  boxSizing: 'border-box',
});
